<template>
	<div>
		<h1 class="cn-font primary--text mb-3">Kurzbeschreibung</h1>
		<h3 class="cn-font grey--text mb-6 mt-6 light">Ermittlung Ihres Digitalisierungsgrades</h3>
		<div class="text-large">		
			<p>
				CHECK IT NOW ist ein steuerungswirksames Reifegradmodell, das nach einer konzisen Erhebungsphase wissenschaftlich fundiert und praktisch anwendbare Ergebnisse zum Digitalisierungsgrad in Ihrer Gesundheitseinrichtung ermittelt.
			</p>
			<p>
				Diese können für eine zielgerichtete und prozessorientierte Zuweisung von (Förder-)Mitteln im Rahmen des KHZG genutzt werden und versetzen die Einrichtungen in die Lage eigene Versorgungsprozesse zu evaluieren und zielgerichtet zu gestalten
			</p>
			
			

		</div>
	</div>
</template>

<script>
	export default{
		name: "About",
	}
</script>